import { Button, Input } from "@material-ui/core";

interface OptionalTextInputProps {
    value: string | null;
    setValue: (value: string | null) => void;
    initialValue: string;
    setButtonText: string;
    resetButtonText: string;
    labelText: string;
}

const OptionalTextInput = ({ value, setValue, initialValue, setButtonText, resetButtonText, labelText }: OptionalTextInputProps) => {
    if (value === null) {
        return <Button size="small" variant="contained" onClick={() => setValue(initialValue)}>{setButtonText}</Button>;
    }

    return <>
        <Button size="small" variant="contained" onClick={() => setValue(null)}>{resetButtonText}</Button>
        <label>{labelText} <Input type="text" value={value} onChange={e => setValue(e.target.value)} /></label>
    </>;
}

export default OptionalTextInput;